import merge from 'deepmerge';
import { ThemeParser } from '../../../core/theme';
import { combineMerge } from '../../../model/util/array';

export const PARADIGM = {
  // eslint-disable-next-line no-magic-numbers
  symbolSize: [12, 144]
};

const defaultSeriesOption = {
  dvSymbol: 'circle',
  dvSymbolSize: PARADIGM.symbolSize,
  clip: true,
  label: {
    dvAutoLayout: true,
    fontSize: 12,
    color: 'rgba(0,0,0,0.84)',
    fontFamily: 'THSMoneyfont-Medium'
  },
  dvItemStyle: [
    {
      id: 'group',
      focus: 'self'
    },
    {
      id: 'circle',
      emphasis: {
        style: {
          opacity: 1
        }
      },
      style: {
        opacity: 0.6
      },
      blur: {
        style: {
          opacity: 0.1
        }
      }
    }
  ]
};
const defaultXAxisOption = {
  type: 'value',
  silent: true,
  dvNameLocation: 'center',
  nameGap: 8,
  nameTextStyle: {
    fontSize: 14,
    fontFamily: ' MicrosoftYaHei',
    color: '#70717D'
  },
  axisLabel: {
    show: true,
    margin: 8,
    color: '#70717D',
    fontSize: 14,
    fontFamily: 'ArialMT'
  },
  axisLine: {
    show: true,
    lineStyle: {
      width: 1,
      color: '#757699',
      opacity: 0.45
    }
  },
  splitLine: {
    show: true,
    lineStyle: {
      width: 0.5,
      color: '#ECECF7'
    }
  },
  axisTick: { show: false }
};
const defaultYAxisOption = {
  type: 'value',
  silent: true,
  dvNameLocation: 'left',
  nameGap: 8,
  nameTextStyle: {
    fontSize: 14,
    fontFamily: ' MicrosoftYaHei',
    color: '#70717D'
  },
  axisLabel: {
    show: true,
    margin: 8,
    color: '#70717D',
    fontSize: 14,
    fontFamily: 'ArialMT'
  },
  axisLine: {
    show: true,
    lineStyle: {
      width: 1,
      color: '#757699',
      opacity: 0.45
    }
  },
  splitLine: {
    show: true,
    lineStyle: {
      width: 0.5,
      color: '#ECECF7'
    }
  },
  axisTick: { show: false }
};
const defaultAxisPointerOption = {
  show: true,
  label: {
    show: false,
    fontSize: 0
  },
  lineStyle: {
    type: [5, 4],
    color: '#757699'
  }
};

function parseXAxis(option) {
  option.xAxis = merge(defaultXAxisOption, option.xAxis || {});
}

function parseYAxis(option) {
  option.yAxis = merge(defaultYAxisOption, option.yAxis || {});
}

function parseAxisPointer(option) {
  option.axisPointer = merge(defaultAxisPointerOption, option.axisPointer || {});
}

function parseSeries(option) {
  option.series = option.series.map(seriesItem => {
    return merge(defaultSeriesOption, seriesItem, {
      customMerge: key => {
        if (key === 'dvItemStyle') {
          return (a, b) => merge(a, b, { arrayMerge: combineMerge('id') });
        }
      }
    });
  });
}
export function dvScatterThemeParse(...args: Parameters<ThemeParser>): ReturnType<ThemeParser> {
  const option = args[0];

  if (typeof option?.series === 'undefined') {
    return;
  }

  const dvScatterSeries = option.series.filter(item => item.type === 'dvScatter');
  if (dvScatterSeries.length === 0) {
    return;
  }

  parseXAxis(option);
  parseYAxis(option);
  parseSeries(option);
  parseAxisPointer(option);
}
